import { useQuery } from "@tanstack/react-query";
import { getCurrentPlan } from "../../products";
import { notification } from "antd";

export const useFetchCurrentPlan = () => {
  return useQuery({
    queryKey: ["getCurrentPlan"], // ✅ Fixed typo in key
    queryFn: () => getCurrentPlan(), // ✅ No params
    staleTime: 5 * 60 * 1000, // optional for caching
    refetchOnWindowFocus: false, // optional to prevent unwanted re-fetches
    onError: () => {
      notification.error({
        key: "getCurrentPlanError",
        message: "Failed to retrieve current plan",
      });
    },
  });
};
